<main class="container-fluid px-0 irembogov-template-preview mt-n5 pt-1">
  <!-- Loading State -->
  <irembogov-irembo-loading-circle-spinner
    *ngIf="isLoading"></irembogov-irembo-loading-circle-spinner>

  <!-- Error State -->
  <ng-container *ngIf="loadError && !isLoading">
    <div class="col-8 mx-auto mt-5 text-center">
      <irembogov-irembo-section-message
        title="Error: Template Not Found"
        message="The requested template could not be found or you don't have permission to view it."
        [type]="'danger'">
      </irembogov-irembo-section-message>
      <button class="btn btn-primary mt-3" (click)="goBack()">
        <i class="fas fa-arrow-left me-2"></i>
        Back to Templates
      </button>
    </div>
  </ng-container>

  <!-- Template Preview Content -->
  <ng-container *ngIf="!isLoading && !loadError && template">
    <!-- Header - Match Create/Edit Template Design -->
    <div class="bg-white">
      <div class="container-fluid px-4 py-3">
        <!-- Breadcrumb -->
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb mb-3">
            <li class="breadcrumb-item">
              <a routerLink="/services/templates" class="text-decoration-none"
                >Service Templates</a
              >
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ template.name }}
            </li>
          </ol>
        </nav>

        <!-- Title and Actions -->
        <div class="d-flex justify-content-between align-items-start mb-3">
          <div class="flex-grow-1">
            <h1 class="h5 mb-2 fw-bold">{{ template.name }}</h1>
            <div
              class="d-flex align-items-center gap-3 mb-2"
              *ngIf="template.description">
              <span
                class="text-muted"
                [innerHTML]="template.description | slice : 0 : 80"></span>
              <span
                *ngIf="template.description && template.description.length > 80"
                class="text-muted"
                >...</span
              >
            </div>
          </div>

          <div class="d-flex gap-2 ms-3">
            <!-- <button type="button" class="btn btn-primary" (click)="useTemplate()">
              <i class="fas fa-plus me-2"></i>
              Use This Template
            </button> -->
            <button type="button" class="btn btn-primary" (click)="goBack()">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Configuration Steps Preview -->
    <irembogov-configure-service-change-request-stepper
      [configSteps]="previewSteps"
      [selectedIndex]="currentPreviewStep"
      [showIndexInLabel]="true"
      (selectionChange)="onStepChange($event.selectedIndex)">
      <cdk-step
        [label]="item.label"
        *ngFor="let item of previewSteps; let index = index"
        [hasError]="previewSteps[index].hasError"
        [completed]="previewSteps[index].isComplete">
        <ng-container *ngTemplateOutlet="getCurrentTemplate(index)">
        </ng-container>
      </cdk-step>
    </irembogov-configure-service-change-request-stepper>
  </ng-container>
</main>

<!-- Template definitions for each preview step -->
<ng-template #overview>
  <div class="template-preview-section">
    <div class="container-fluid px-4 py-4">
      <div class="row justify-content-center">
        <div class="col-12 col-xl-10">
          <div class="mb-4">
            <!-- Template Details Grid -->
            <div class="row g-4">
              <!-- Basic Information -->
              <div class="col-lg-8">
                <div class="card h-100">
                  <div
                    class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">
                      <i class="fas fa-info-circle me-2"></i>
                      Basic Information
                    </h5>
                  </div>
                  <div class="card-body">
                    <div class="row g-3">
                      <div class="col-md-6">
                        <label class="form-label fw-semibold text-muted"
                          >Template Name</label
                        >
                        <p class="h6 mb-0">{{ template.name }}</p>
                      </div>
                      <div class="col-md-6">
                        <label class="form-label fw-semibold text-muted"
                          >Status</label
                        >
                        <div>
                          <irembogov-service-template-status-badge
                            [status]="
                              template.status
                            "></irembogov-service-template-status-badge>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label class="form-label fw-semibold text-muted"
                          >Service Type</label
                        >
                        <div>
                          <span class="fs-6 py-2">
                            {{ template.serviceType }}
                          </span>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="template.trafficClass">
                        <label class="form-label fw-semibold text-muted"
                          >Traffic Class</label
                        >
                        <div>
                          <span class="fs-6 py-2">{{
                            template.trafficClass
                          }}</span>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="template.applicantType">
                        <label class="form-label fw-semibold text-muted"
                          >Applicant Type</label
                        >
                        <div>
                          <span class="fs-6 py-2">{{
                            template.applicantType
                          }}</span>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="template.categoryName">
                        <label class="form-label fw-semibold text-muted"
                          >Category</label
                        >
                        <p class="mb-0">
                          <i class="fas fa-folder me-2 text-muted"></i
                          >{{ template.categoryName }}
                        </p>
                      </div>
                    </div>

                    <div *ngIf="template.description" class="mt-4">
                      <label class="form-label fw-semibold text-muted"
                        >Description</label
                      >
                      <div class="border rounded p-3 bg-light">
                        <div [innerHTML]="template.description"></div>
                      </div>
                    </div>

                    <div *ngIf="template.knowledgeBaseUrl" class="mt-4">
                      <label class="form-label fw-semibold text-muted"
                        >Knowledge Base</label
                      >
                      <div>
                        <a
                          [href]="template.knowledgeBaseUrl"
                          target="_blank"
                          class="btn btn-outline-primary">
                          <i class="fas fa-external-link-alt me-2"></i>
                          View Knowledge Base Article
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Timeline and Stats -->
              <div class="col-lg-4">
                <div class="card h-100">
                  <div
                    class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">
                      <i class="fas fa-chart-line me-2"></i>
                      Usage & Timeline
                    </h5>
                  </div>
                  <div class="card-body">
                    <div class="text-center mb-4">
                      <div class="display-6 fw-bold text-primary">
                        {{ template.usageCount || 0 }}
                      </div>
                      <small class="text-muted">Times Used</small>
                    </div>

                    <hr />

                    <div class="timeline">
                      <div class="timeline-item mb-3">
                        <div class="timeline-marker bg-primary"></div>
                        <div class="timeline-content">
                          <label class="form-label fw-semibold text-muted mb-1"
                            >Created</label
                          >
                          <p class="mb-0 small">
                            <i class="fas fa-calendar me-2"></i>
                            {{
                              template.dateCreated
                                | date : "MMM d, y 'at' h:mm a"
                            }}
                          </p>
                        </div>
                      </div>

                      <div
                        class="timeline-item mb-3"
                        *ngIf="template.publishedDate">
                        <div class="timeline-marker bg-primary"></div>
                        <div class="timeline-content">
                          <label class="form-label fw-semibold text-muted mb-1"
                            >Published</label
                          >
                          <p class="mb-0 small">
                            <i class="fas fa-rocket me-2"></i>
                            {{
                              template.publishedDate
                                | date : "MMM d, y 'at' h:mm a"
                            }}
                          </p>
                        </div>
                      </div>

                      <div
                        class="timeline-item"
                        *ngIf="template.lastModifiedDate">
                        <div class="timeline-marker bg-warning"></div>
                        <div class="timeline-content">
                          <label class="form-label fw-semibold text-muted mb-1"
                            >Last Modified</label
                          >
                          <p class="mb-0 small">
                            <i class="fas fa-edit me-2"></i>
                            {{
                              template.lastModifiedDate
                                | date : "MMM d, y 'at' h:mm a"
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #journeymapping>
  <div class="template-preview-section">
    <div class="d-flex">
      <div class="ms-5 me-5 w-100">
        <div class="mx-auto mt-5">
          <div class="card">
            <div
              class="card-header d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                <i class="fas fa-map me-2"></i>
                Journey Mapping Configuration
              </h6>
              <span
                class="badge"
                [class]="
                  getStepStatus('journeymapping')
                    ? 'bg-primary'
                    : 'bg-secondary'
                ">
                {{
                  getStepStatus('journeymapping')
                    ? 'Configured'
                    : 'Not Configured'
                }}
              </span>
            </div>
            <div class="card-body">
              <div
                *ngIf="!getStepStatus('journeymapping')"
                class="text-center py-4">
                <i class="fas fa-exclamation-triangle fa-3x mb-3"></i>
                <h6>No Journey Mapping Configuration</h6>
                <p class="text-muted">
                  This template doesn't have journey mapping configured.
                </p>
              </div>

              <div *ngIf="getStepStatus('journeymapping')">
                <div class="alert alert-info">
                  <i class="fas fa-info-circle me-2"></i>
                  Journey mapping has been configured for this template. This
                  defines the service mapping and workflow structure for
                  journey-type services.
                </div>

                <!-- Show journey mapping details if available -->
                <div *ngIf="templateJourneyMappingData" class="mt-3">
                  <h6>Journey Configuration Summary</h6>
                  <div class="json-preview">
                    <details>
                      <summary class="btn btn-outline-secondary btn-sm">
                        View Journey Mapping Data
                      </summary>
                      <pre class="bg-light p-3 rounded mt-2">{{
                        templateJourneyMappingData | json
                      }}</pre>
                    </details>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #formbuilder>
  <div class="template-preview-section">
    <div class="container-fluid px-4 py-4">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="mb-4">
            <!-- No Form Configuration State -->
            <div *ngIf="!getStepStatus('formbuilder')" class="text-center py-5">
              <i class="fas fa-exclamation-triangle fa-4x mb-4"></i>
              <h4>No Form Configuration</h4>
              <p class="text-muted lead">
                This template doesn't have any form fields configured.
              </p>
            </div>

            <!-- Form Preview (Default View) -->
            <div
              *ngIf="getStepStatus('formbuilder') && !showFormSummary"
              class="form-preview-container">
              <div class="card border-0 shadow-sm">
                <div class="card-header">
                  <h5 class="mb-0">
                    <i class="fas fa-eye me-2"></i>
                    Live Form Preview - {{ template.name }}
                  </h5>
                  <small class="opacity-75"
                    >This is how the form will appear to users</small
                  >
                </div>
                <div class="card-body p-4">
                  <irembogov-preview-service-change-request-json-formdata-widget>
                  </irembogov-preview-service-change-request-json-formdata-widget>
                </div>
              </div>
            </div>

            <!-- Form Summary (Optional View) -->
            <div
              *ngIf="getStepStatus('formbuilder') && showFormSummary"
              class="form-summary-container">
              <div class="row g-4">
                <!-- Stats Card -->
                <div class="col-lg-4">
                  <div class="card h-100">
                    <div class="card-header">
                      <h5 class="mb-0">
                        <i class="fas fa-chart-bar me-2 text-info"></i>
                        Form Statistics
                      </h5>
                    </div>
                    <div class="card-body text-center">
                      <div class="row g-3">
                        <div class="col-6">
                          <div class="display-6 fw-bold text-primary">
                            {{ getSectionCount() }}
                          </div>
                          <small class="text-muted">Sections</small>
                        </div>
                        <div class="col-6">
                          <div class="display-6 fw-bold text-primary">
                            {{ getTotalFieldCount() }}
                          </div>
                          <small class="text-muted">Fields</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Form Structure -->
                <div class="col-lg-8">
                  <div class="card h-100">
                    <div class="card-header">
                      <h5 class="mb-0">
                        <i class="fas fa-sitemap me-2 text-primary"></i>
                        Form Structure
                      </h5>
                    </div>
                    <div class="card-body">
                      <div
                        *ngIf="
                          templateFormData && hasObjectKeys(templateFormData)
                        ">
                        <div class="accordion" id="formSectionsAccordion">
                          <div
                            *ngFor="
                              let section of templateFormData | keyvalue;
                              let i = index
                            "
                            class="accordion-item">
                            <h2 class="accordion-header" [id]="'heading' + i">
                              <button
                                class="accordion-button"
                                [class.collapsed]="i !== 0"
                                type="button"
                                data-bs-toggle="collapse"
                                [attr.data-bs-target]="'#collapse' + i"
                                [attr.aria-expanded]="i === 0"
                                [attr.aria-controls]="'collapse' + i">
                                <div class="d-flex align-items-center gap-3">
                                  <i class="fas fa-folder text-primary"></i>
                                  <strong>{{ section.key }}</strong>
                                  <span class="badge bg-primary"
                                    >{{
                                      section?.value?.length || 0
                                    }}
                                    fields</span
                                  >
                                </div>
                              </button>
                            </h2>
                            <div
                              [id]="'collapse' + i"
                              class="accordion-collapse collapse"
                              [class.show]="i === 0"
                              [attr.aria-labelledby]="'heading' + i"
                              data-bs-parent="#formSectionsAccordion">
                              <div class="accordion-body">
                                <div
                                  *ngIf="
                                    section.value && section.value.length > 0
                                  "
                                  class="row g-2">
                                  <div
                                    *ngFor="let field of section.value"
                                    class="col-md-6">
                                    <div class="border rounded p-3 h-100">
                                      <div
                                        class="d-flex justify-content-between align-items-start mb-2">
                                        <div>
                                          <h6 class="mb-1">
                                            {{ field.key || field.id }}
                                          </h6>
                                          <small
                                            class="text-muted"
                                            *ngIf="
                                              field.templateOptions?.label
                                            ">
                                            {{ field.templateOptions?.label }}
                                          </small>
                                        </div>
                                        <div class="text-end">
                                          <span
                                            class="badge bg-secondary mb-1"
                                            >{{ field.type }}</span
                                          >
                                          <br />
                                          <span
                                            class="badge"
                                            [class]="
                                              field.templateOptions?.required
                                                ? 'bg-danger'
                                                : 'bg-success'
                                            ">
                                            {{
                                              field.templateOptions?.required
                                                ? 'Required'
                                                : 'Optional'
                                            }}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  *ngIf="
                                    !section.value || section.value.length === 0
                                  "
                                  class="text-center py-3">
                                  <i class="fas fa-inbox text-muted mb-2"></i>
                                  <p class="text-muted mb-0">
                                    No fields in this section
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #pricing>
  <div class="template-preview-section">
    <div class="d-flex">
      <div class="ms-5 me-5 w-100">
        <div class="mx-auto mt-5">
          <div class="card">
            <div
              class="card-header d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                <i class="fas fa-money-bill-1-wave me-2"></i>
                Pricing Configuration
              </h6>
              <span
                class="badge"
                [class]="
                  getStepStatus('pricing') ? 'bg-primary' : 'bg-secondary'
                ">
                {{ getStepStatus('pricing') ? 'Configured' : 'Not Configured' }}
              </span>
            </div>
            <div class="card-body">
              <div *ngIf="!getStepStatus('pricing')" class="text-center py-4">
                <i class="fas fa-exclamation-triangle fa-3x mb-3"></i>
                <h6>No Pricing Configuration</h6>
                <p class="text-muted">
                  This template doesn't have pricing configured.
                </p>
              </div>

              <div *ngIf="getStepStatus('pricing')" class="pricing-preview">
                <irembogov-template-preview-pricing
                  *ngIf="templatePricingData"
                  [pricingData]="templatePricingData">
                </irembogov-template-preview-pricing>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #workflow>
  <div class="template-preview-section">
    <div class="container-fluid px-4 py-4">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="mb-4">
            <!-- No Workflow Configuration State -->
            <div *ngIf="!getStepStatus('workflow')" class="text-center py-5">
              <i class="fas fa-exclamation-triangle fa-4x mb-4"></i>
              <h4>No Workflow Configuration</h4>
              <p class="text-muted lead">
                This template doesn't have a workflow configured.
              </p>
            </div>

            <!-- Visual Workflow (Default View) -->
            <div
              *ngIf="getStepStatus('workflow') && !showWorkflowRaw"
              class="workflow-visual-container">
              <div class="card border-0 shadow-sm">
                <div class="card-header">
                  <h5 class="mb-0">
                    <i class="fas fa-sitemap me-2"></i>
                    Workflow Summary - {{ template.name }}
                  </h5>
                  <small class="opacity-75"
                    >Visual representation of the workflow configuration</small
                  >
                </div>
                <div class="card-body p-0" style="min-height: 400px">
                  <!-- Workflow Visual Editor -->
                  <div
                    #statePreviewer
                    class="workflow_step_body w-100 mb-3"
                    style="height: 80vh">
                    <irembogov-state-machine-preview
                      [workflowCode]="
                        templateWorkflowData['workflow']
                      "></irembogov-state-machine-preview>
                  </div>
                </div>
              </div>
            </div>

            <!-- Raw Workflow Data (Optional View) -->
            <div
              *ngIf="getStepStatus('workflow') && showWorkflowRaw"
              class="workflow-raw-container">
              <div class="row g-4">
                <!-- Workflow Summary -->
                <div class="col-lg-4">
                  <div class="card h-100">
                    <div class="card-header">
                      <h5 class="mb-0">
                        <i class="fas fa-chart-bar me-2 text-info"></i>
                        Workflow Statistics
                      </h5>
                    </div>
                    <div class="card-body">
                      <div
                        class="text-center mb-3"
                        *ngIf="getWorkflowSummary()?.stepCount">
                        <div class="display-6 fw-bold text-primary">
                          {{ getWorkflowSummary()?.stepCount }}
                        </div>
                        <small class="text-muted">Workflow Steps</small>
                      </div>

                      <div class="workflow-features">
                        <div class="d-flex align-items-center mb-2">
                          <i class="fas fa-code-branch text-success me-2"></i>
                          <span class="small">
                            {{
                              getWorkflowSummary()?.hasConditionalLogic
                                ? 'Has conditional logic'
                                : 'Simple workflow'
                            }}
                          </span>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                          <i class="fas fa-check-circle text-primary me-2"></i>
                          <span class="small">Approval process defined</span>
                        </div>
                        <div class="d-flex align-items-center">
                          <i class="fas fa-route me-2"></i>
                          <span class="small">Routing logic configured</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Raw Workflow Data -->
                <!-- <div class="col-lg-8">
                  <div class="card h-100">
                    <div class="card-header bg-secondary text-white">
                      <h5 class="mb-0">
                        <i class="fas fa-file-code me-2"></i>
                        Workflow JSON Configuration
                      </h5>
                    </div>
                    <div class="card-body p-3" style="max-height: 500px; overflow-y: auto">
                      <div class="workflow-json-container">
                        <pre class="mb-0 small text-muted">{{
                          templateWorkflowData | json
                        }}</pre>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #officerform>
  <div class="template-preview-section">
    <div class="container-fluid px-4 py-4">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="mb-4">
            <!-- Officer Form Content - Always show this section -->
            <div class="card border-0 shadow-sm">
              <div class="card-header">
                <h5 class="mb-0">
                  <i
                    class="fas"
                    [ngClass]="
                      getStepStatus('officerform')
                        ? 'fa-check-circle'
                        : 'fa-cog'
                    "></i>
                  Officer Form Step
                </h5>
                <small class="opacity-75">
                  {{
                    getStepStatus('officerform')
                      ? 'This step is configured and ready for use'
                      : 'This step is available for configuration'
                  }}
                </small>
              </div>
              <div class="card-body p-4">
                <!-- When NOT configured -->
                <div
                  *ngIf="!getStepStatus('officerform')"
                  class="text-center py-4">
                  <div class="row justify-content-center">
                    <div class="col-md-8">
                      <i class="fas fa-cog fa-4x text-muted mb-4"></i>
                      <h4>Officer Form Step Available</h4>
                      <p class="text-muted lead mb-4">
                        This step is available for configuration. Officers will
                        be able to process applications using the default
                        workflow capabilities.
                      </p>
                      <div class="alert alert-primary">
                        <i class="fas fa-info-circle me-2"></i>
                        <strong>Default Capabilities:</strong> Officers can
                        perform standard workflow operations:
                        <ul class="mb-0 mt-2 text-start">
                          <li>View application details</li>
                          <li>Add comments and notes</li>
                          <li>Approve or reject applications</li>
                          <li>Move applications through workflow steps</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- When configured -->
                <div *ngIf="getStepStatus('officerform')">
                  <div class="row g-4">
                    <div class="col-lg-8">
                      <div class="alert alert-primary">
                        <i class="fas fa-check-circle me-2"></i>
                        <strong>Officer Form Configured:</strong> This template
                        has custom officer form fields for enhanced processing
                        capabilities.
                      </div>

                      <!-- Officer form summary -->
                      <div *ngIf="templateThirdPartyFormData" class="mt-3">
                        <h6>Officer Form Features</h6>
                        <div class="card bg-light border">
                          <div class="card-body">
                            <div class="row g-3">
                              <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                  <i
                                    class="fas fa-check-circle text-primary me-2"></i>
                                  <span class="small"
                                    >Custom form fields defined</span
                                  >
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                  <i
                                    class="fas fa-check-circle text-primary me-2"></i>
                                  <span class="small"
                                    >Officer-specific validation rules</span
                                  >
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                  <i
                                    class="fas fa-check-circle text-primary me-2"></i>
                                  <span class="small"
                                    >Workflow integration ready</span
                                  >
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                  <i
                                    class="fas fa-check-circle text-primary me-2"></i>
                                  <span class="small"
                                    >Data capture configured</span
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="card h-100">
                        <div class="card-header">
                          <h6 class="mb-0">
                            <i class="fas fa-cogs me-2 text-primary"></i>
                            Configuration Status
                          </h6>
                        </div>
                        <div class="card-body text-center">
                          <div class="mb-3">
                            <i
                              class="fas fa-check-circle fa-3x text-primary"></i>
                          </div>
                          <h6 class="text-primary">Fully Configured</h6>
                          <p class="small text-muted mb-0">
                            Officer form is ready for production use
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Raw data toggle -->
                  <!-- <div class="mt-4">
                    <div class="d-flex justify-content-between align-items-center">
                      <h6>Raw Configuration Data</h6>
                      <button class="btn btn-outline-secondary btn-sm" type="button" data-bs-toggle="collapse"
                        data-bs-target="#officerFormRawData" aria-expanded="false" aria-controls="officerFormRawData">
                        <i class="fas fa-code me-2"></i>
                        View JSON
                      </button>
                    </div>
                    <div class="collapse mt-3" id="officerFormRawData">
                      <div class="card bg-light border">
                        <div class="card-header bg-secondary text-white">
                          <small><i class="fas fa-file-code me-2"></i>Officer Form
                            Configuration JSON</small>
                        </div>
                        <div class="card-body p-3" style="max-height: 400px; overflow-y: auto">
                          <pre class="mb-0 small text-muted">{{
                            templateThirdPartyFormData | json
                          }}</pre>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #translation>
  <div class="template-preview-section">
    <div class="d-flex">
      <div class="ms-5 me-5 w-100">
        <div class="mx-auto mt-5">
          <div class="card">
            <div class="card-body">
              <div
                *ngIf="!getStepStatus('translation')"
                class="text-center py-4">
                <i class="fas fa-exclamation-triangle fa-3x mb-3"></i>
                <h6>No Translation Configuration</h6>
                <p class="text-muted">
                  This template doesn't have translations configured.
                </p>
              </div>

              <div *ngIf="getStepStatus('translation')">
                <div class="row g-4">
                  <!-- Language Overview -->
                  <div class="col-lg-4">
                    <div class="card h-100">
                      <div class="card-header">
                        <h6 class="mb-0">
                          <i class="fas fa-globe me-2 text-primary"></i>
                          Available Languages
                        </h6>
                      </div>
                      <div class="card-body">
                        <div class="d-flex flex-wrap gap-2 mb-3">
                          <span
                            *ngFor="
                              let lang of templateTranslationData | keyvalue
                            "
                            class="badge bg-info fs-6 px-3 py-2">
                            <i class="fas fa-globe me-1"></i>{{ lang.key }}
                          </span>
                        </div>

                        <div class="text-center mt-3">
                          <div class="display-6 fw-bold text-primary">
                            {{
                              (templateTranslationData | keyvalue)?.length || 0
                            }}
                          </div>
                          <small class="text-muted">Languages Supported</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Translation Details -->
                  <div class="col-lg-8">
                    <div class="card h-100">
                      <div class="card-header">
                        <h6 class="mb-0">
                          <i class="fas fa-table me-2 text-primary"></i>
                          Translation Details
                        </h6>
                      </div>
                      <div class="card-body">
                        <div
                          class="table-responsive"
                          *ngIf="templateTranslationData">
                          <table class="table table-hover">
                            <thead class="table-dark">
                              <tr>
                                <th>Language</th>
                                <th>Translated Fields</th>
                                <th>Field Details</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                *ngFor="
                                  let translation of templateTranslationData
                                    | keyvalue
                                ">
                                <td>
                                  <span class="badge bg-info fs-6 px-3 py-2">
                                    <i class="fas fa-globe me-1"></i
                                    >{{ translation.key }}
                                  </span>
                                </td>
                                <td>
                                  <span class="fw-bold text-primary">{{
                                    getTranslationFieldCount(translation.value)
                                  }}</span>
                                  fields
                                </td>
                                <td>
                                  <div
                                    class="small"
                                    *ngIf="
                                      hasTranslationFields(translation.value)
                                    ">
                                    <div class="d-flex flex-wrap gap-1">
                                      <span
                                        *ngFor="
                                          let field of getTranslationFieldsSafe(
                                            translation.value
                                          ) | slice : 0 : 3
                                        "
                                        class="badge bg-light text-dark border">
                                        {{ field }}
                                      </span>
                                      <span
                                        *ngIf="
                                          getTranslationFieldsSafe(
                                            translation.value
                                          ).length > 3
                                        "
                                        class="badge bg-secondary">
                                        +{{
                                          getTranslationFieldsSafe(
                                            translation.value
                                          ).length - 3
                                        }}
                                        more
                                      </span>
                                    </div>
                                  </div>
                                  <span
                                    *ngIf="
                                      !hasTranslationFields(translation.value)
                                    "
                                    class="text-muted small">
                                    No fields
                                  </span>
                                </td>
                                <td>
                                  <span class="badge bg-success">
                                    <i class="fas fa-check me-1"></i>Configured
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Detailed Field Breakdown -->
                <div class="mt-4" *ngIf="templateTranslationData">
                  <div class="card">
                    <div class="card-header">
                      <h6 class="mb-0">
                        <i class="fas fa-list-alt me-2 text-primary"></i>
                        All Translated Fields by Language
                      </h6>
                    </div>
                    <div class="card-body">
                      <div class="accordion" id="translationFieldsAccordion">
                        <div
                          *ngFor="
                            let translation of templateTranslationData
                              | keyvalue;
                            let i = index
                          "
                          class="accordion-item">
                          <h2
                            class="accordion-header"
                            [id]="'translationHeading' + i">
                            <button
                              class="accordion-button"
                              [class.collapsed]="i !== 0"
                              type="button"
                              data-bs-toggle="collapse"
                              [attr.data-bs-target]="'#translationCollapse' + i"
                              [attr.aria-expanded]="i === 0"
                              [attr.aria-controls]="'translationCollapse' + i">
                              <div class="d-flex align-items-center gap-3">
                                <i class="fas fa-globe text-primary"></i>
                                <strong>{{ translation.key }}</strong>
                                <span class="badge bg-info"
                                  >{{
                                    getTranslationFieldCount(translation.value)
                                  }}
                                  fields</span
                                >
                              </div>
                            </button>
                          </h2>
                          <div
                            [id]="'translationCollapse' + i"
                            class="accordion-collapse collapse"
                            [class.show]="i === 0"
                            [attr.aria-labelledby]="'translationHeading' + i"
                            data-bs-parent="#translationFieldsAccordion">
                            <div class="accordion-body">
                              <div
                                *ngIf="hasTranslationFields(translation.value)"
                                class="row g-2">
                                <div
                                  *ngFor="
                                    let field of getTranslationFieldsSafe(
                                      translation.value
                                    )
                                  "
                                  class="col-md-4">
                                  <div class="border rounded p-2 bg-light">
                                    <small class="fw-semibold text-primary">{{
                                      field
                                    }}</small>
                                  </div>
                                </div>
                              </div>
                              <div
                                *ngIf="!hasTranslationFields(translation.value)"
                                class="text-center py-3">
                                <i class="fas fa-inbox text-muted mb-2"></i>
                                <p class="text-muted mb-0">
                                  No translated fields for this language
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Raw Data Toggle -->
                <div class="mt-4">
                  <div class="d-flex justify-content-center">
                    <button
                      class="btn btn-outline-primary"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#translationRawData"
                      aria-expanded="false"
                      aria-controls="translationRawData">
                      <i class="fas fa-code me-2"></i>
                      View Raw Translation Data
                    </button>
                  </div>
                  <div class="collapse mt-3" id="translationRawData">
                    <div class="card bg-light">
                      <div class="card-body">
                        <pre class="mb-0">{{
                          templateTranslationData | json
                        }}</pre>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
